// Liga a grade à garagem do B1: pinta o selo nos cards, submete a ordenação na troca do
// <select> e preserva o ?view= da pré-visualização de template.
// A decisão de PINTAR é do núcleo (deveMostrarSelo); aqui só tem DOM.
const core = await window.ArpineDS.importar("core");
const { garagem } = await window.ArpineDS.importar("garagem");
const { deveMostrarSelo } = await window.ArpineDS.importar("colecao");

const raiz = document.querySelector("[data-ds-colecao], [data-ds-busca]");
if (raiz) {
  // O SERVIDOR já disse se a grade está filtrada por veículo (collection.filters).
  // Não lemos a URL aqui: duas fontes de verdade uma hora divergem.
  const filtrada = raiz.dataset.dsFiltradoPorVeiculo === "1";
  const modelo = raiz.dataset.dsSelo || "";

  function pintarSelos() {
    const veiculo = garagem.ativo();
    for (const selo of raiz.querySelectorAll("[data-ds-card-fit]")) {
      const produto = {
        marca: selo.dataset.marca,
        modelo: selo.dataset.modelo,
        anos: (selo.dataset.anos || "").split(",").map((a) => a.trim()).filter(Boolean),
      };
      const mostrar = modelo !== "" && deveMostrarSelo({ filtrada, produto, veiculo });
      selo.hidden = !mostrar;
      if (mostrar) {
        // textContent sempre: nome de veículo é dado de quem navega.
        selo.querySelector("[data-ds-card-fit-texto]").textContent =
          core.fillTemplate(modelo, { veiculo: core.labelVeiculo(veiculo) });
      }
    }
  }

  // Quem filtra a coleção pelo veículo salvo é o ds-colecao-veiculo.js, do B1 — aqui não.
  // Este módulo só pinta o selo dos cards.
  pintarSelos();
  // Trocou de veículo em outra parte da página (ou em outra aba): repinta sem recarregar.
  // DOCUMENT, não window: ds-garagem.js emite com document.dispatchEvent e SEM bubbles,
  // então um listener em window nunca receberia nada. É o que os outros módulos do B1 fazem.
  document.addEventListener(core.EVENTO, pintarSelos);

  // Ordenação: com JS o select submete sozinho e o botão some (o CSS esconde via [data-js]).
  const ordem = raiz.querySelector("[data-ds-ordem]");
  if (ordem) {
    raiz.dataset.js = "";
    ordem.querySelector("select").addEventListener("change", () => ordem.submit());
  }

  // ?view=<sufixo> é como se pré-visualiza o template de categoria ANTES da escrita do
  // templateSuffix na loja. O form de ordenação é GET sem action: submeter joga fora todo
  // parâmetro que não seja campo do form, e os links de "limpar"/"voltar ao começo" saem do
  // Liquid sem ele — nos dois casos a pessoa cairia no layout de RESERVA no meio do teste.
  // O Liquid não expõe o parâmetro (não existe request.view), então quem repara é o JS.
  const view = new URLSearchParams(location.search).get("view");
  if (view) {
    if (ordem && !ordem.querySelector('[name="view"]')) {
      const campo = document.createElement("input");
      campo.type = "hidden";
      campo.name = "view";
      campo.value = view;
      ordem.appendChild(campo);
    }
    for (const a of raiz.querySelectorAll("a[data-ds-view-keep][href]")) {
      const url = new URL(a.href, location.origin);
      url.searchParams.set("view", view);
      a.href = url.pathname + url.search + url.hash;
    }
  }
}
